var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTablerStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.7913L4.85667 17.4955L5.83917 11.768L1.6725 7.71214L7.4225 6.8788L9.99417 1.66797L12.5658 6.8788L18.3158 7.71214L14.1492 11.768L15.1317 17.4955L10 14.7913Z",
    fill: "#E0E400",
    stroke: "#E0E400",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablerStar);
export default __webpack_public_path__ + "static/media/tabler_star.55f893b4351592a85fd049181a12dcfd.svg";
export { ForwardRef as ReactComponent };